var map = {
	"./assembleDetail.js": "da6b",
	"./assemblePage.js": "892f",
	"./myAssemble.js": "d1d0",
	"./orderConfirm.js": "8d18",
	"./productDetail.js": "867c",
	"./testModule.js": "ab63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8860";